export enum Severity {
  Fatal = "fatal",
  Critical = "critical",
  Error = "error",
  Warning = "warning",
  Log = "log",
  Info = "info",
  Debug = "debug",
}
